import request from '../../../api/request';

const BASE = '/maintainers-portal/financial-portal/debt-publication';

export type DebtPublicationTrigger = 'cron' | 'manual';
export type DebtPublicationStatus = 'success' | 'failed' | 'dry_run';

export interface DebtPublicationRun {
  id: number;
  provider: string;
  trigger: DebtPublicationTrigger;
  fileName: string | null;
  rowsOpen: number;
  rowsClosed: number;
  rowsVoided: number;
  rowsExcluded: number;
  totalAmount: number;
  status: DebtPublicationStatus;
  errorDetail: string | null;
  startedAt: string;
  finishedAt: string | null;
}

export interface DebtPublicationConfig {
  enabled: boolean;
  provider: string | null;
}

export interface DebtPublicationRunResult {
  status: string;
  fileName: string | null;
  rowsOpen: number;
}

/**
 * Shared Pagination shape used across the API (see PaymentHistory,
 * StudentList): `{ data, total, total_pages }`, NOT `{ data, total }`.
 */
export interface DebtPublicationRunsResponse {
  data: DebtPublicationRun[];
  total: number;
  total_pages: number;
}

export function getConfig() {
  return request<DebtPublicationConfig>(`${BASE}/config`);
}

export function getRuns(page: number, items: number) {
  return request<DebtPublicationRunsResponse>(`${BASE}/runs`, {
    params: { page, items },
  });
}

export function runNow(dryRun = false) {
  return request<DebtPublicationRunResult>(`${BASE}/run`, {
    method: 'post',
    data: { dryRun },
  });
}

export function getRunFileUrl(id: number) {
  return request<{ url: string }>(`${BASE}/runs/${id}/file`);
}
